import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatedCurlyBracket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M7.96 4.907c-1.26 0-2.298.957-2.298 2.156V8.53c0 .192-.134.37-.343.43l-.866.25a.8.8 0 0 0 0 1.555l.866.25c.21.061.343.239.343.43v1.466c0 1.2 1.038 2.157 2.299 2.157h.588c.384 0 .71-.293.71-.673s-.326-.672-.71-.672h-.588c-.493 0-.877-.372-.877-.812v-1.465c0-.592-.308-1.129-.795-1.458.487-.33.795-.866.795-1.458V7.063c0-.44.384-.81.877-.81h.588c.384 0 .71-.294.71-.674s-.326-.672-.71-.672zm3.49 0c-.383 0-.71.293-.71.672s.326.673.71.673h.59c.492 0 .876.371.876.811V8.53c0 .592.308 1.128.795 1.458-.487.33-.795.866-.795 1.458v1.465c0 .44-.384.812-.877.812h-.588c-.385 0-.711.293-.711.672s.326.673.71.673h.59c1.26 0 2.297-.958 2.297-2.157v-1.465c0-.192.135-.37.344-.43l.866-.25a.8.8 0 0 0 0-1.556l-.866-.25a.46.46 0 0 1-.344-.43V7.063c0-1.199-1.037-2.156-2.298-2.156h-.588Z" />
    <path
      fillRule="evenodd"
      d="M1.667 3.802c0-.604.497-1.094 1.11-1.094h1.667c.307 0 .556.245.556.547a.55.55 0 0 1-.556.547H2.778v12.395h1.666c.307 0 .556.245.556.547a.55.55 0 0 1-.556.547H2.778c-.614 0-1.111-.49-1.111-1.094zm16.666 0c0-.604-.497-1.094-1.11-1.094h-1.667a.55.55 0 0 0-.556.547c0 .302.249.547.556.547h1.666v12.395h-1.667a.55.55 0 0 0-.555.547c0 .302.249.547.556.547h1.666c.614 0 1.111-.49 1.111-1.094z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRepeatedCurlyBracket;
